/**
 * Mixin pojedynczej akcji
 */
export const actionMixin = {
  props: {
    // Obiekt zawierający dane
    object: {
      type: Object,
      required: true
    },
    // Akcja see: intrefaces/action.ts
    action: {
      type: Object,
      required: true
    }
  },

  computed: {
    // @vuese
    // Zwraca kolor akcji
    actionColor() {
      if (typeof this.action.color === 'function') {
        return this.action.color(this.object);
      }
      return this.action.color;
    }
  }
};
